@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.template-editor-modal {
  height: 100%;
}

.template-info {
  padding: @space-12;
}

.field {
  width: 30%;

  label {
    font-weight: 500;
    padding-bottom: @space-4;
  }
}

.commonSectionHeaderMixin() {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 @space-16;
}

.editors {
  padding: @space-12;

  .section-wrapper {
    margin-bottom: @space-4;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .closed-section {
    border: 1px solid @settings-page--templates-packing-slips-edit-closed--border-color;
    border-radius: 4px;
    background-color: @settings-page--templates-packing-slips-edit-closed--background-color;
    cursor: pointer;
    transition:
      background-color 0.2s ease,
      border-color 0.2s ease;
    .commonSectionHeaderMixin();

    &:hover {
      background-color: var(--grey-100);
      border-color: var(--grey-400);
    }
  }

  .open-section {
    border: 1px solid @settings-page--templates-packing-slips-edit-open--border-color;
    border-radius: 4px 4px 0 0;
    background-color: @settings-page--templates-packing-slips-edit-open--background-color;
    cursor: pointer;
    .commonSectionHeaderMixin();
  }
}

.section-title {
  color: var(--grey-900);
  flex-shrink: 0;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;

  button {
    margin-left: 5px;
  }
}

.loading {
  position: unset;
}

.ai-banner {
  margin: @space-12 @space-12 0;
}
